import React from 'react';
import styled, { css } from 'styled-components';
import { themeColor } from '../../Theming';
import { Link, LinkProps } from 'react-router-dom';
import { ArrowHead } from '../../Common/Svg/Icons';

const sharedStyling = css`
  border-top: 1px solid ${themeColor('lightestGrey')};
  color: ${themeColor('darkestGrey')};
  font-size: 1rem;
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-decoration: none;
  text-transform: uppercase;
`;

const StyledLink = styled(Link)`
  ${sharedStyling}
`;

export const StyledMenuButton = styled.a`
  ${sharedStyling}
`;

interface MenuLinkProps {
  to: string | LinkProps['to'];
  hideArrow?: boolean;
  target?: LinkProps['target'];
}

const MenuLink: React.FC<MenuLinkProps> = ({
  children,
  to,
  hideArrow = false,
  target,
}) => {
  return (
    <StyledLink to={to} target={target}>
      {children}
      {!hideArrow && <ArrowHead rotateDimensions width={12} height={6} />}
    </StyledLink>
  );
};

export default MenuLink;
